/**
 * In-card variant (size) selector for the standard product card.
 * Clicking an option updates the card's price, image, sale badge, links and
 * the add-to-cart button's variant id. Sold-out options are inert.
 */
(function () {
  var CARD = ".product-item";
  var OPTION = "[data-card-variant-option]";
  var SELECTOR = "[data-card-variant-selector]";
  var VARIANT_ITEM = ".product-item__variant-selector-item";
  var ADD_TO_CART = "[data-variant-click-atc]";
  var QUICK_VIEW_BTN = ".show-product-quickview";

  function shouldBlockSliderPointer(target) {
    if (!target || !target.closest) {
      return false;
    }

    var card = target.closest(CARD);
    if (!card) {
      return false;
    }

    return !!(
      target.closest(VARIANT_ITEM) ||
      target.closest(ADD_TO_CART) ||
      target.closest(QUICK_VIEW_BTN)
    );
  }

  // Stop Swiper from treating clicks (with slight mouse movement) as a drag.
  function blockSliderPointer(event) {
    if (!shouldBlockSliderPointer(event.target)) {
      return;
    }
    event.stopPropagation();
  }

  document.addEventListener("pointerdown", blockSliderPointer, true);
  document.addEventListener("mousedown", blockSliderPointer, true);
  document.addEventListener("touchstart", blockSliderPointer, {
    capture: true,
    passive: true,
  });

  function setSelected(card, button) {
    card.querySelectorAll(OPTION).forEach(function (option) {
      var isActive = option === button;
      option.classList.toggle("is-selected", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updatePrice(card, data) {
    var priceEl = card.querySelector("[data-card-price]");
    if (!priceEl) return;

    var unitPriceContainer = priceEl.querySelector(
      "[data-unit-price-container]",
    );

    if (data.onSale === "true") {
      priceEl.innerHTML =
        '<span class="sale"></span><span class="regular"></span>';
      priceEl.querySelector(".sale").textContent = data.price;
      priceEl.querySelector(".regular").textContent = data.compareAtPrice;
    } else {
      priceEl.innerHTML = "<span></span>";
      priceEl.querySelector("span").textContent = data.price;
    }

    if (unitPriceContainer) {
      priceEl.appendChild(unitPriceContainer);
      updateUnitPrice(unitPriceContainer, data);
    }

    [
      "data-original-price",
      "data-original-html",
      "data-original-price-prefix",
      "data-ne-discount-applied",
      "data-ne-discount-signature",
    ].forEach(function (attribute) {
      priceEl.removeAttribute(attribute);
    });

    document.dispatchEvent(
      new CustomEvent("ne:discount-reapply", {
        detail: {
          priceElement: priceEl,
          productId:
            card.getAttribute("data-product-id") ||
            card.getAttribute("data-productId"),
          priceCents: Number(data.priceCents || 0),
        },
      }),
    );
  }

  function updateUnitPrice(container, data) {
    var isAvailable = data.hasUnitPrice === "true";
    var price = container.querySelector("[data-unit-price]");
    var separator = container.querySelector("[data-unit-price-separator]");
    var base = container.querySelector("[data-unit-price-base-unit]");
    var priceRow = container.querySelector(".unit-price__price");
    var referenceValue = String(data.unitPriceReferenceValue || "");
    var referenceUnit = String(data.unitPriceReferenceUnit || "");
    var baseUnit =
      referenceValue && referenceValue !== "1"
        ? referenceValue + referenceUnit
        : referenceUnit;

    container.classList.toggle("unit-price--available", isAvailable);
    if (priceRow) {
      priceRow.classList.toggle("unit-price--available", isAvailable);
    }
    if (price) price.textContent = isAvailable ? data.unitPrice : "";
    if (separator) separator.textContent = isAvailable ? "/" : "";
    if (base) base.textContent = isAvailable ? baseUnit : "";
  }

  function updateImage(card, data) {
    if (!data.image) return;
    var img = card.querySelector("[data-card-image-link] img");
    if (!img) return;
    img.removeAttribute("srcset");
    img.src = data.image;
  }

  function updateLinks(card, variantId) {
    card.querySelectorAll('a[href*="variant="]').forEach(function (link) {
      link.href = link.href.replace(/variant=\d+/, "variant=" + variantId);
    });
  }

  function updateSaleBadge(card, data) {
    var badges = card.querySelector(".product-badges");
    if (!badges) return;

    var saleBadge = badges.querySelector(".product-badge--sale");

    if (data.onSale === "true" && data.saleBadge) {
      if (!saleBadge) {
        saleBadge = document.createElement("div");
        saleBadge.className = "product-badge product-badge--sale";
        badges.insertBefore(saleBadge, badges.firstChild);
      }
      saleBadge.textContent = data.saleBadge;
    } else if (saleBadge) {
      saleBadge.remove();
    }
  }

  function updateAtcButton(card, variantId) {
    var atc = card.querySelector("[data-card-atc]");
    if (atc) atc.setAttribute("data-variant-id", variantId);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(OPTION);
    if (!button) return;

    if (button.disabled || button.getAttribute("data-available") !== "true") {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var card = button.closest(CARD);
    if (!card) return;

    var data = button.dataset;
    var variantId = data.variantId;

    setSelected(card, button);
    updatePrice(card, data);
    updateImage(card, data);
    updateSaleBadge(card, data);
    updateLinks(card, variantId);
    updateAtcButton(card, variantId);
    card.setAttribute("data-variantId", variantId);
  });

  // --- Desktop scroll chevrons -------------------------------------------

  var LIST = "[data-card-variant-list]";

  function updateChevrons(selector) {
    var list = selector.querySelector(LIST);
    if (!list) return;
    var prev = selector.querySelector('[data-card-variant-scroll="prev"]');
    var next = selector.querySelector('[data-card-variant-scroll="next"]');

    var maxScroll = list.scrollWidth - list.clientWidth;
    var overflows = maxScroll > 1;

    if (prev)
      prev.classList.toggle("is-visible", overflows && list.scrollLeft > 1);
    if (next)
      next.classList.toggle(
        "is-visible",
        overflows && list.scrollLeft < maxScroll - 1,
      );
  }

  function initSelector(selector) {
    if (selector.dataset.cardVariantReady) return;
    var list = selector.querySelector(LIST);
    if (!list) return;
    selector.dataset.cardVariantReady = "true";

    selector
      .querySelectorAll("[data-card-variant-scroll]")
      .forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var amount = Math.max(list.clientWidth * 0.8, 120);
          var dir =
            btn.getAttribute("data-card-variant-scroll") === "prev" ? -1 : 1;
          list.scrollBy({ left: amount * dir, behavior: "smooth" });
        });
      });

    list.addEventListener("scroll", function () {
      updateChevrons(selector);
    });

    updateChevrons(selector);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSelector);
  }

  window.addEventListener("resize", function () {
    document.querySelectorAll(SELECTOR).forEach(updateChevrons);
  });

  // Re-init selectors added after load (e.g. collection filtering).
  if (window.MutationObserver) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        initAll();
      });
    }).observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  initAll();
})();
